import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./i18n";
import { supabase } from "@/integrations/supabase/client";
import { getVisitorId } from "@/lib/visitor";

// Inject the visitor identifier as a trusted request header so RLS policies
// can scope INSERT/UPDATE/DELETE on votes & reactions to the row owner.
try {
  const visitorId = getVisitorId();
  // @ts-expect-error - rest.headers is a mutable record on the PostgrestClient
  supabase.rest.headers["x-visitor-id"] = visitorId;
  // @ts-expect-error - mirror onto storage client for any future use
  if (supabase.storage?.headers) supabase.storage.headers["x-visitor-id"] = visitorId;
} catch {
  // best-effort; no fatal error if internals change
}

createRoot(document.getElementById("root")!).render(<App />);
